'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  display: flex;
  font-size: 18px;
  align-items: center;
  gap: 0.25rem;
  color: ${theme.colors.neutral[3]};
  font-weight: 600;
  cursor: pointer;
  &:hover {
    color: ${theme.colors.neutral[1]};
  }
`;

const middle = parseInt(theme.sizes.screens.md, 10) + (parseInt(theme.sizes.screens.lg, 10) - parseInt(theme.sizes.screens.md, 10)) / 2;

export const label = css`
  display: none;
  @media screen and (width > ${middle}px) {
    display: initial;
  }
`;
